export enum SideMenuItemUrl {
  Home = "/home",
  Activities = "/activities",
  Patients = "/patients",
  ProgramTemplates = "/program-templates",
  Reports = "/reports",
}
